export class Region {
  regionId: string | undefined = undefined;
  regionName: string = '';
}
